import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { validateForm } from "src/app/shared/validators";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "formly-field-surveyradio",
  styleUrls: ["./common.css"],
  template: `<ng-container>
      <div>
        <mat-label>{{ props.question.identifierText }}</mat-label>
        <ul class="checkbox">
          @for (option of props.question.options; track option) {
            <li>
              <mat-radio-button
                [formlyAttributes]="field"
                [disabled]="props.disabled"
                [value]="option.value"
                [id]="option.id"
                [ngModel]="myModel[option.value]"
                (ngModelChange)="onModelChange(option.value)"
                >
                {{ option.name }}
              </mat-radio-button>
            </li>
          }
        </ul>
        <mat-hint class="error" align="start">{{
          getErrorMessage(props.question.id)
        }}</mat-hint>
      </div>
      @if (props.question?.showCommentBox) {
        <br />
        <mat-form-field appearance="fill" floatLabel="always" class="comments">
          <mat-label>Comments</mat-label>
          <textarea
            [id]="props.question?.id + '-comments'"
            [ngModel]="commentModel"
            rows="4"
            class="form-field"
            matInput
            (blur)="onBlurEvent($event)"
            [disabled]="props.disabled"
          ></textarea>
        </mat-form-field>
      }
    </ng-container>`,
  animations: [
    trigger("animateState", [
      state(
        "inactive",
        style({
          backgroundColor: "default",
        })
      ),
      state(
        "saving",
        style({
          backgroundColor: "silver",
        })
      ),
      state(
        "saved",
        style({
          backgroundColor: "green",
        })
      ),
      transition("* => *", animate(2000)),
    ]),
  ],
  standalone: false,
})
export class FormlyFieldSurveyRadioComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  public myModel = {};
  public commentModel: string;
  commentKey: string;

  getErrorMessage(key: string): string {
    return validateForm(this.form, key);
  }

  ngOnInit(): void {
    const modelValue = this.model[this.key.toString()] || "";

    const possibleAnswers = modelValue.split(";");

    this.props.question.options.forEach((item) => {
      this.myModel[item["value"]] = possibleAnswers.includes(item["value"]);
    });

    this.commentKey = this.key.toString() + "-comments";
    this.commentModel = this.model[this.commentKey] || "";
  }

  public onModelChange(key: string) {
    this.myModel[key] = !this.myModel[key];

    this.formControl.setValue(
      Object.keys(this.myModel)
        .filter((i) => this.myModel[i] === true)
        .map((i) => i + ";")
        .join("")
    );
  }

  onBlurEvent(event: any) {
    this.model[this.commentKey] = event.target.value;
    this.formControl.updateValueAndValidity();
  }
}
